import React, { useEffect, useState } from "react";
import CustomModal from "../../common/general/CustomModal/CustomModal";
import EditModule from "../EditModule/EditModule";

const EditModuleNameModalContainer = ({ visible, onClose, moduleName, onUpdateModuleName, moduleId }) => {
  const [newModuleName, setNewModuleName] = useState(moduleName);

  useEffect(() => {
    if (moduleName) {
      setNewModuleName(moduleName);
    } else {
      setNewModuleName("");
    }

    return () => {
      setNewModuleName("");
    };
  }, [visible, moduleName]);

  return (
    <CustomModal visible={visible} onRequestClose={onClose}>
      <EditModule
        onChangeName={setNewModuleName}
        moduleName={newModuleName ?? moduleName}
        saveButtonClick={() => onUpdateModuleName(moduleName, newModuleName, moduleId)}
        cancelButtonClick={onClose}
      />
    </CustomModal>
  );
};

export default EditModuleNameModalContainer;
